export const environment = {
  production: true,
  apiBase: 'https://arumid.org/api/api'
};
